import React from 'react';
import classNames from 'classnames';

import styles from './style.scss';


const EmptyFilterResult = () => (
  <div className={classNames(styles.container, 'cy-jest-empty-filter-result')} >
    <span className={styles.icon} />
    <p className="title-2">Ничего не найдено</p>
  </div>
);

export default EmptyFilterResult;
